// ------------------------------------------------------------
// Application Bootstrap File
// ------------------------------------------------------------
// This file is the main entry point for the React application.
// It attaches the React component tree to the DOM, sets up the
// Redux store provider, and initializes global styles.
//
// Features included:
// - React.StrictMode for highlighting potential issues
// - Redux <Provider> for global state management
// - Application root component: <App />
// - Global stylesheet import (index.css)
// ------------------------------------------------------------

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "@/store/store";
import App from "./App.jsx";
import "./index.css";

/**
 * Render Application
 * ------------------------------------------------------------
 * Creates the React root and renders the App component wrapped
 * in necessary providers (Redux, StrictMode).
 */
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
